import importAll from './importAll';
const files = require.context('./../en', true, /\.json$/);

const messages = importAll(files);
export default {
	messages
}
